// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   CircularProgress,
// } from "@mui/material";
// import { Gavel } from "@mui/icons-material";
// import api from "../../../api/axiosInterceptor";
// import { SnackBarComponent } from "../../../Components/snackBar/snackBar";

// const ACTIONS = {
//   public: {
//     staff: [
//       {
//         a: "submit",
//         l: "Submit",
//         c: "primary",
//         s: ["draft", "rejected_l1", "rejected_l2", "rejected_l3"],
//       },
//     ],
//     super_staff: [
//       {
//         a: "submit",
//         l: "Submit",
//         c: "primary",
//         s: ["draft", "rejected_l1", "rejected_l2", "rejected_l3"],
//       },
//     ],
//     shirastedar: [
//       {
//         a: "submit",
//         l: "Submit",
//         c: "primary",
//         s: ["draft", "rejected_l1", "rejected_l2", "rejected_l3"],
//       },
//       { a: "approve_l1", l: "Approve", c: "success", s: ["submitted"] },
//       { a: "reject_l1", l: "Reject", c: "error", s: ["submitted"] },
//     ],
//     tahsildar: [
//       { a: "approve_l2", l: "Approve", c: "success", s: ["approved_l1"] },
//       { a: "reject_l2", l: "Reject", c: "error", s: ["approved_l1"] },
//     ],
//     competent_authority: [
//       { a: "approve_l3", l: "Approve", c: "success", s: ["approved_l2"] },
//       { a: "reject_l3", l: "Reject", c: "error", s: ["approved_l2"] },
//       { a: "finalise", l: "Finalise", c: "primary", s: ["approved_l3"] },
//     ],
//     sploca: [
//       { a: "finalise", l: "Finalise", c: "primary", s: ["approved_l3"] },
//     ],
//     admin: [
//       { a: "approve_l3", l: "Approve", c: "success", s: ["approved_l2"] },
//       { a: "reject_l3", l: "Reject", c: "error", s: ["approved_l2"] },
//       { a: "finalise", l: "Finalise", c: "primary", s: ["approved_l3"] },
//     ],
//   },
//   legal: {
//     staff: [
//       {
//         a: "submit",
//         l: "Submit",
//         c: "primary",
//         s: [
//           "draft",
//           "rejected_l1",
//           "rejected_ac",
//           "rejected_js",
//           "rejected_ca",
//         ],
//       },
//     ],
//     super_staff: [
//       {
//         a: "submit",
//         l: "Submit",
//         c: "primary",
//         s: [
//           "draft",
//           "rejected_l1",
//           "rejected_ac",
//           "rejected_js",
//           "rejected_ca",
//         ],
//       },
//     ],
//     shirastedar: [
//       {
//         a: "submit",
//         l: "Submit",
//         c: "primary",
//         s: [
//           "draft",
//           "rejected_l1",
//           "rejected_ac",
//           "rejected_js",
//           "rejected_ca",
//         ],
//       },
//       {
//         a: "approve_shira",
//         l: "Send to Legal",
//         c: "success",
//         s: ["submitted"],
//       },
//       { a: "reject_shira", l: "Reject", c: "error", s: ["submitted"] },
//     ],
//     legal: [
//       { a: "approve_legal", l: "Approve", c: "success", s: ["legal_review"] },
//       { a: "reject_legal", l: "Reject", c: "error", s: ["legal_review"] },
//     ],
//     assistant_commissioner: [
//       { a: "approve_ac", l: "Approve", c: "success", s: ["approved_l1"] },
//       { a: "reject_ac", l: "Reject", c: "error", s: ["approved_l1"] },
//     ],
//     joint_secretary: [
//       { a: "approve_js", l: "Approve", c: "success", s: ["approved_ac"] },
//       { a: "reject_js", l: "Reject", c: "error", s: ["approved_ac"] },
//     ],
//     competent_authority: [
//       {
//         a: "approve_ca",
//         l: "Approve & Sign",
//         c: "success",
//         s: ["approved_js"],
//       },
//       { a: "reject_ca", l: "Reject", c: "error", s: ["approved_js"] },
//       { a: "issue", l: "Issue", c: "primary", s: ["approved_ca"] },
//     ],
//     sploca: [
//       { a: "approve_ca", l: "Approve", c: "success", s: ["approved_js"] },
//       { a: "reject_ca", l: "Reject", c: "error", s: ["approved_js"] },
//       { a: "issue", l: "Issue", c: "primary", s: ["approved_ca"] },
//     ],
//     admin: [{ a: "issue", l: "Issue", c: "primary", s: ["approved_ca"] }],
//   },
//   petition: {
//     legal: [
//       {
//         a: "submit",
//         l: "Submit for Review",
//         c: "primary",
//         s: [
//           "draft",
//           "rejected_l1",
//           "rejected_ac",
//           "rejected_js",
//           "rejected_ca",
//         ],
//       },
//       { a: "approve_legal", l: "Approve", c: "success", s: ["legal_review"] },
//       { a: "reject_legal", l: "Reject", c: "error", s: ["legal_review"] },
//     ],
//     assistant_commissioner: [
//       { a: "approve_ac", l: "Approve", c: "success", s: ["approved_l1"] },
//       { a: "reject_ac", l: "Reject", c: "error", s: ["approved_l1"] },
//     ],
//     joint_secretary: [
//       { a: "approve_js", l: "Approve", c: "success", s: ["approved_ac"] },
//       { a: "reject_js", l: "Reject", c: "error", s: ["approved_ac"] },
//     ],
//     competent_authority: [
//       { a: "approve_ca", l: "Approve", c: "success", s: ["approved_js"] },
//       { a: "reject_ca", l: "Reject", c: "error", s: ["approved_js"] },
//       { a: "issue", l: "Issue", c: "primary", s: ["approved_ca"] },
//     ],
//     sploca: [
//       { a: "approve_ca", l: "Approve", c: "success", s: ["approved_js"] },
//       { a: "reject_ca", l: "Reject", c: "error", s: ["approved_js"] },
//       { a: "issue", l: "Issue", c: "primary", s: ["approved_ca"] },
//     ],
//     admin: [{ a: "issue", l: "Issue", c: "primary", s: ["approved_ca"] }],
//   },
// };

// const ApprovalPanel = ({ form, apiPath, role, flowType, onRefresh }) => {
//   const [remarks, setRemarks] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [snack, setSnack] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });

//   const available = (ACTIONS[flowType]?.[role] || []).filter((a) =>
//     a.s.includes(form.status),
//   );
//   if (!available.length) return null;

//   const doAction = async (action) => {
//     setLoading(true);
//     try {
//       await api.post(`${apiPath}${form.id}/action/`, { action, remarks });
//       setSnack({
//         open: true,
//         message: "Action completed successfully",
//         severity: "success",
//       });
//       onRefresh();
//     } catch (e) {
//       setSnack({
//         open: true,
//         message: e.response?.data?.error || "Action failed",
//         severity: "error",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         mt: 3,
//         p: 2,
//         border: "1px solid #e0e0e0",
//         borderRadius: 2,
//         background: "#f5f5f5",
//       }}
//     >
//       <Typography variant="subtitle2" fontWeight="bold" mb={1}>
//         <Gavel fontSize="small" sx={{ mr: 0.5, verticalAlign: "middle" }} />
//         Available Actions
//       </Typography>
//       <TextField
//         fullWidth
//         size="small"
//         label="Remarks (optional)"
//         value={remarks}
//         onChange={(e) => setRemarks(e.target.value)}
//         multiline
//         rows={2}
//         sx={{ mb: 2 }}
//       />
//       <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
//         {available.map((a) => (
//           <Button
//             key={a.a}
//             variant="contained"
//             color={a.c}
//             size="small"
//             disabled={loading}
//             onClick={() => doAction(a.a)}
//             startIcon={loading ? <CircularProgress size={14} /> : null}
//           >
//             {a.l}
//           </Button>
//         ))}
//       </Box>
//       <SnackBarComponent
//         open={snack.open}
//         message={snack.message}
//         severity={snack.severity}
//         onClose={() => setSnack((s) => ({ ...s, open: false }))}
//       />
//     </Box>
//   );
// };

// export default ApprovalPanel;



import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { Gavel } from "@mui/icons-material";
import api from "../../../api/axiosInterceptor";
import { SnackBarComponent } from "../../../Components/snackBar/snackBar";

// ─────────────────────────────────────────────────────────────────────────────
// ACTION MAP
//
// public  — unchanged sequential flow
// legal   — after approved_l1, AC / JS / CA+SPLOCA can each approve directly
// petition — same flatten: after approved_l1, AC / JS / CA+SPLOCA directly
// ─────────────────────────────────────────────────────────────────────────────
const ACTIONS = {
  // ── PUBLIC RECORD (unchanged) ─────────────────────────────────────────────
  public: {
    staff: [
      {
        a: "submit",
        l: "Submit",
        c: "primary",
        s: ["draft", "rejected_l1", "rejected_l2", "rejected_l3"],
      },
    ],
    super_staff: [
      {
        a: "submit",
        l: "Submit",
        c: "primary",
        s: ["draft", "rejected_l1", "rejected_l2", "rejected_l3"],
      },
    ],
    shirastedar: [
      {
        a: "submit",
        l: "Submit",
        c: "primary",
        s: ["draft", "rejected_l1", "rejected_l2", "rejected_l3"],
      },
      { a: "approve_l1", l: "Approve", c: "success", s: ["submitted"] },
      { a: "reject_l1",  l: "Reject",  c: "error",   s: ["submitted"] },
    ],
    tahsildar: [
      { a: "approve_l2", l: "Approve", c: "success", s: ["approved_l1"] },
      { a: "reject_l2",  l: "Reject",  c: "error",   s: ["approved_l1"] },
    ],
    competent_authority: [
      { a: "approve_l3", l: "Approve",  c: "success", s: ["approved_l2"] },
      { a: "reject_l3",  l: "Reject",   c: "error",   s: ["approved_l2"] },
      { a: "finalise",   l: "Finalise", c: "primary",  s: ["approved_l3"] },
    ],
    sploca: [
      { a: "finalise", l: "Finalise", c: "primary", s: ["approved_l3"] },
    ],
    admin: [
      { a: "approve_l3", l: "Approve",  c: "success", s: ["approved_l2"] },
      { a: "reject_l3",  l: "Reject",   c: "error",   s: ["approved_l2"] },
      { a: "finalise",   l: "Finalise", c: "primary",  s: ["approved_l3"] },
    ],
  },

  // ── LEGAL (Summons / Warrant) ─────────────────────────────────────────────
  // After approved_l1 each senior role sees only their own approve/reject.
  // After their own approval they can issue directly.
  legal: {
    staff: [
      {
        a: "submit",
        l: "Submit",
        c: "primary",
        s: ["draft", "rejected_l1", "rejected_ac", "rejected_js", "rejected_ca"],
      },
    ],
    super_staff: [
      {
        a: "submit",
        l: "Submit",
        c: "primary",
        s: ["draft", "rejected_l1", "rejected_ac", "rejected_js", "rejected_ca"],
      },
    ],
    shirastedar: [
      {
        a: "submit",
        l: "Submit",
        c: "primary",
        s: ["draft", "rejected_l1", "rejected_ac", "rejected_js", "rejected_ca"],
      },
      { a: "approve_shira", l: "Send to Legal", c: "success", s: ["submitted"] },
      { a: "reject_shira",  l: "Reject",        c: "error",   s: ["submitted"] },
    ],
    legal: [
      { a: "approve_legal", l: "Approve", c: "success", s: ["legal_review"] },
      { a: "reject_legal",  l: "Reject",  c: "error",   s: ["legal_review"] },
    ],
    // AC: approve or reject from approved_l1; then issue from approved_ac
    assistant_commissioner: [
      { a: "approve_ac", l: "Approve", c: "success", s: ["approved_l1"] },
      { a: "reject_ac",  l: "Reject",  c: "error",   s: ["approved_l1"] },
      { a: "issue",      l: "Issue",   c: "primary",  s: ["approved_ac"] },
      { a: "reject_ac",  l: "Reject",  c: "error",   s: ["approved_ac"] },
    ],
    // JS: approve or reject from approved_l1; then issue from approved_js
    joint_secretary: [
      { a: "approve_js", l: "Approve", c: "success", s: ["approved_l1"] },
      { a: "reject_js",  l: "Reject",  c: "error",   s: ["approved_l1"] },
      { a: "issue",      l: "Issue",   c: "primary",  s: ["approved_js"] },
      { a: "reject_js",  l: "Reject",  c: "error",   s: ["approved_js"] },
    ],
    // CA/SPLOCA: approve or reject from approved_l1; then issue from approved_ca
    competent_authority: [
      { a: "approve_ca", l: "Approve & Sign", c: "success", s: ["approved_l1"] },
      { a: "reject_ca",  l: "Reject",         c: "error",   s: ["approved_l1"] },
      { a: "issue",      l: "Issue",           c: "primary",  s: ["approved_ca"] },
    ],
    sploca: [
      { a: "approve_ca", l: "Approve", c: "success", s: ["approved_l1"] },
      { a: "reject_ca",  l: "Reject",  c: "error",   s: ["approved_l1"] },
      { a: "issue",      l: "Issue",   c: "primary",  s: ["approved_ca"] },
    ],
    admin: [
      { a: "issue", l: "Issue", c: "primary", s: ["approved_ca", "approved_ac", "approved_js"] },
    ],
  },

  // ── PETITION ──────────────────────────────────────────────────────────────
  // Same flatten: Legal submits → legal_review → approved_l1
  // then AC / JS / CA+SPLOCA approve independently.
  petition: {
    legal: [
      {
        a: "submit",
        l: "Submit for Review",
        c: "primary",
        s: ["draft", "rejected_l1", "rejected_ac", "rejected_js", "rejected_ca"],
      },
      { a: "approve_legal", l: "Approve", c: "success", s: ["legal_review"] },
      { a: "reject_legal",  l: "Reject",  c: "error",   s: ["legal_review"] },
    ],
    // AC: approve or reject from approved_l1; then issue from approved_ac
    assistant_commissioner: [
      { a: "approve_ac", l: "Approve", c: "success", s: ["approved_l1"] },
      { a: "reject_ac",  l: "Reject",  c: "error",   s: ["approved_l1"] },
      { a: "issue",      l: "Issue",   c: "primary",  s: ["approved_ac"] },
      { a: "reject_ac",  l: "Reject",  c: "error",   s: ["approved_ac"] },
    ],
    // JS: approve or reject from approved_l1; then issue from approved_js
    joint_secretary: [
      { a: "approve_js", l: "Approve", c: "success", s: ["approved_l1"] },
      { a: "reject_js",  l: "Reject",  c: "error",   s: ["approved_l1"] },
      { a: "issue",      l: "Issue",   c: "primary",  s: ["approved_js"] },
      { a: "reject_js",  l: "Reject",  c: "error",   s: ["approved_js"] },
    ],
    // CA/SPLOCA: approve or reject from approved_l1; then issue from approved_ca
    competent_authority: [
      { a: "approve_ca", l: "Approve", c: "success", s: ["approved_l1"] },
      { a: "reject_ca",  l: "Reject",  c: "error",   s: ["approved_l1"] },
      { a: "issue",      l: "Issue",   c: "primary",  s: ["approved_ca"] },
    ],
    sploca: [
      { a: "approve_ca", l: "Approve", c: "success", s: ["approved_l1"] },
      { a: "reject_ca",  l: "Reject",  c: "error",   s: ["approved_l1"] },
      { a: "issue",      l: "Issue",   c: "primary",  s: ["approved_ca"] },
    ],
    admin: [
      { a: "issue", l: "Issue", c: "primary", s: ["approved_ca", "approved_ac", "approved_js"] },
    ],
  },
};

const ApprovalPanel = ({ form, apiPath, role, flowType, onRefresh }) => {
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  // Deduplicate: same action+label pair shown once even if listed for multiple statuses
  const rawAvailable = (ACTIONS[flowType]?.[role] || []).filter((a) =>
    a.s.includes(form.status),
  );
  const seen = new Set();
  const available = rawAvailable.filter((a) => {
    const key = `${a.a}|${a.l}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  if (!available.length) return null;

  const doAction = async (action) => {
    setLoading(true);
    try {
      await api.post(`${apiPath}${form.id}/action/`, { action, remarks });
      setSnack({
        open: true,
        message: "Action completed successfully",
        severity: "success",
      });
      onRefresh();
    } catch (e) {
      setSnack({
        open: true,
        message: e.response?.data?.error || "Action failed",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        mt: 3,
        p: 2,
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        background: "#f5f5f5",
      }}
    >
      <Typography variant="subtitle2" fontWeight="bold" mb={1}>
        <Gavel fontSize="small" sx={{ mr: 0.5, verticalAlign: "middle" }} />
        Available Actions
      </Typography>
      <TextField
        fullWidth
        size="small"
        label="Remarks (optional)"
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
        multiline
        rows={2}
        sx={{ mb: 2 }}
      />
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        {available.map((a) => (
          <Button
            key={a.a}
            variant="contained"
            color={a.c}
            size="small"
            disabled={loading}
            onClick={() => doAction(a.a)}
            startIcon={loading ? <CircularProgress size={14} /> : null}
          >
            {a.l}
          </Button>
        ))}
      </Box>
      <SnackBarComponent
        open={snack.open}
        message={snack.message}
        severity={snack.severity}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
      />
    </Box>
  );
};

export default ApprovalPanel;